import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { deepCopy } from 'deep-copy-ts';
import { throwError } from 'rxjs';
import { catchError, take } from 'rxjs/operators';
import { WindowService } from 'src/app/shared/components/window/window.service';
import { UNITS } from 'src/app/shared/pipe/translation.pipe/translation.pipe';
import { Simulation } from 'src/app/simulation/state/simulation.model';
import { SimulationQuery } from 'src/app/simulation/state/simulation.query';
import { SimulationService } from 'src/app/simulation/state/simulation.service';
import { CostElement } from '../model/cost-element';

@Component({
  selector: 'app-cost-elements-list',
  templateUrl: './cost-elements-list.component.html',
  styleUrls: ['./cost-elements-list.component.scss']
})
export class CostElementsListComponent implements OnInit {

  elements: CostElement[];

  searchTerm: string;

  selected: CostElement = null;

  checkError = false;

  UNITS = UNITS;
  ITEM_NAMES = ITEM_NAMES;

  constructor(
    private simulationService: SimulationService,
    private simulationQuery: SimulationQuery,
    private snackBar: MatSnackBar,
    private windowService: WindowService
  ) { }

  ngOnInit(): void {
    const simulation = this.simulationQuery.getActive();
    this.simulationService.getMaterialList(simulation.id)
      .pipe(
        take(1),
        catchError(error => {
          this.checkError = true;
          return throwError(error);
        })
      )
      .subscribe(materials => this.mergeList(simulation, materials));
  }

  edit(element: CostElement) {
    this.selected = element;
  }

  update(el: CostElement) {
    const index = this.elements.findIndex(e => e.name === el.name);
    this.elements[index] = el;
    this.selected = null;
  }

  finish(): void {
    const snackBar = $localize`Material list updated`;
    const simulation = deepCopy(this.simulationQuery.getActive());
    simulation.parameters.cost_elements = this.elements as any;
    this.simulationService.update(simulation.id, simulation)
      .subscribe(() => {
        this.windowService.close(this);
        this.openSnackBar(snackBar, null);
      });
  }

  private mergeList(simulation: Simulation, materials: CostElement[]): void {
    if (simulation.parameters.cost_elements) {
      this.elements = simulation.parameters.cost_elements.map(e => this.fillMaterial(e));
    } else {
      this.elements = [];
    }

    materials.forEach(m => {
      if (!this.elements.find((e) => e.name === m.name)) {
        this.elements.push(this.fillMaterial(m));
      }
    });
  }

  private fillMaterial(el: CostElement): CostElement {
    const newElement = {
      ...el
    };
    if (newElement.cost === undefined) {
      newElement.cost = 0;
    }
    if (newElement.installation_cost === undefined) {
      newElement.installation_cost = 0;
    }
    return newElement;
  }

  private openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 2000,
    });
  }

}

const ITEM_NAMES = {
  'Optical Closure': $localize`Optical Closure`,
  'Optical Termination Closure': $localize`Optical Termination Closure`,
  'External Closure for Connection to Building': $localize`External Closure for Connection to Building`,
  factory_connector: $localize`Factory connector`,
  field_connector: $localize`Field connector`,
  fusion: $localize`Fusion`,
};
